import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { UserClaim } from '@challenger/care/models/user-claim.model';
import { UserToken } from '@challenger/care/models/user-token.model';
import { Select, Store } from '@ngxs/store';

import { AuthenticatingUser, SetUserDetail } from '../actions/user.actions';
import { UserState } from '../states/user.state';

@Injectable({
  providedIn: 'root',
})
export class UserFacade {
  @Select(UserState.getUserDisplayName) userDisplayName$: Observable<string>;
  @Select(UserState.getUserClaims) userClaims$: Observable<UserClaim>;
  @Select(UserState.getUserAccountId) userAccountId$: Observable<string>;
  @Select(UserState.getVMHouseholdId) vmHouseholdId$: Observable<string>;
  @Select(UserState.getError) userError$: Observable<string>;
  @Select(UserState.getIsAuthenticating) isAuthenticating$: Observable<boolean>;
  @Select(UserState.getIdToken) idToken$: Observable<string>;

  constructor(private store: Store) {}

  setUserDetail(claims: UserClaim, accessToken: UserToken, idToken: UserToken) {
    this.store.dispatch(new SetUserDetail({ claims, accessToken, idToken }));
  }

  authenticatingUser(isAuthenticating: boolean) {
    this.store.dispatch(new AuthenticatingUser(isAuthenticating));
  }
}
